import {axiosInstance} from '../helpers'


const url = '/site'

const get = () => axiosInstance.get({url: url, params: null})


export const siteServices = {
  get,
}
